import script from "./ambiguous-background.vue?vue&type=script&setup=true&lang=js"
export * from "./ambiguous-background.vue?vue&type=script&setup=true&lang=js"

import "./ambiguous-background.vue?vue&type=style&index=0&id=3d062269&lang=less"

const __exports__ = script;

export default __exports__